import axios from "axios";

export const GET_XML_VALIDATION = "GET_XML_VALIDATION";
export const GET_NOVEDADES_PRESTADORES_CONECTIVIDAD = "GET_NOVEDADES_PRESTADORES_CONECTIVIDAD";
export const POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD = "POST_NOVEDADES_PRESTADORES_CONECTIVIDAD";
export const GET_SERVICE_MONITOR_STATISTICS = "GET_SERVICE_MONITOR_STATISTICS";
export const GET_XML_NEWS = "GET_XML_NEWS";
export const CLEAR_XML_NEWS = "CLEAR_XML_NEWS";
export const RESEND_XML_NEWS = "RESEND_XML_NEWS";
export const UPDATE_XML_NEWS = "UPDATE_XML_NEWS";
export const GET_INDIVIDUAL_XML_NEWS = "GET_INDIVIDUAL_XML_NEWS";
export const CLEAR_INDIVIDUAL_XML_NEWS = "CLEAR_INDIVIDUAL_XML_NEWS";

export const getServiceMonitorStatistics = (wriId) => (dispatch) => {
    return dispatch({
        type: GET_SERVICE_MONITOR_STATISTICS,
        payload: axios
            .get(`connectivity/serviceMonitorStatistics?wriId=${wriId}`)
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    })
}

export const getXMLValidation = (xmlCode, form) => (dispatch) => {
    return dispatch({
        type: GET_XML_VALIDATION,
        payload: axios
            .post(
                `connectivity/ValidateXML?form=${form}`,
                { XmlCode: xmlCode },
            )
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
}

export const getNovedadesPrestadorConectividad = (queryParams) => (dispatch) => {
    return dispatch({
        type: GET_NOVEDADES_PRESTADORES_CONECTIVIDAD,
        payload: axios
            .get(`connectivity/providerNews`,
                {
                    params: {
                        wriId: queryParams?.wriId,
                        dateFrom: queryParams?.dateFrom,
                        dateTo: queryParams?.dateTo,
                        document: queryParams?.document,
                        providerId: queryParams?.providerId,
                        newsType: queryParams?.newsType,
                    },
                }
            )
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const postNovedadesPrestadorConectividad = (novedades) => (dispatch) => {
    return dispatch({
        type: POST_REENVIAR_NOVEDADES_PRESTADORES_CONECTIVIDAD,
        payload: axios.post(`connectivity/renewProviderNews`, novedades)

            .then((response) => {
                return { data: response.data };
            })
            .catch((error) => {
                return Promise.reject(error);
            })
    })
};

export const getXmlNews = (wriId, tipoFormulario, fechaDesde, fechaHasta, cuitPrestador, dniTrabajador) => (dispatch) => {
    return dispatch({
        type: GET_XML_NEWS,
        payload: axios
            .get(`connectivity/xmlNews`, {
                params: {
                    wriId,
                    tipoFormulario,
                    fechaDesde,
                    fechaHasta,
                    cuitPrestador,
                    dniTrabajador
                }
            })
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
}

export const clearXmlNews = () => (dispatch) => {
    return dispatch({
        type: CLEAR_XML_NEWS,
    });
}

export const resendXmlNews = (wriId, idsToUpdate) => (dispatch) => {
    return dispatch({
        type: RESEND_XML_NEWS,
        payload: axios
            .post(`connectivity/resendXmlNews?wriId=${wriId}`, { idsToUpdate })
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const updateXmlNews = (idsToUpdate) => (dispatch) => {
    return dispatch({
        type: UPDATE_XML_NEWS,
        payload: idsToUpdate
    });
};

export const getIndividualXmlNews = (wriId, novedadId) => (dispatch) => {
    return dispatch({
        type: GET_INDIVIDUAL_XML_NEWS,
        payload: axios
            .get(`connectivity/individualXmlNews`, {
                params: {
                    wriId,
                    novedadId
                }
            })
            .then((response) => ({ data: response.data }))
            .catch((error) => Promise.reject(error)),
    });
};

export const clearIndividualXmlNews = () => (dispatch) => {
    return dispatch({
        type: CLEAR_INDIVIDUAL_XML_NEWS,
    });
};
